// extracted by mini-css-extract-plugin
module.exports = {"SomeoneElseTag":"member-operations__SomeoneElse__SomeoneElseTag"};